export const CONNECTOR_ERROR_CODES = {
    NOT_IMPLEMENTED: "NOT_IMPLEMENTED",
    PROVIDER_NOT_CONFIGURED: "PROVIDER_NOT_CONFIGURED",
    PROVIDER_TIMEOUT: "PROVIDER_TIMEOUT",
    PROVIDER_RATE_LIMITED: "PROVIDER_RATE_LIMITED",
    PROVIDER_UNAVAILABLE: "PROVIDER_UNAVAILABLE",
    PROVIDER_HTTP_ERROR: "PROVIDER_HTTP_ERROR",
    PROVIDER_AUTH_FAILED: "PROVIDER_AUTH_FAILED",
    INTERNAL_ERROR: "INTERNAL_ERROR",
    CONNECTOR_OFFLINE: "CONNECTOR_OFFLINE",
    CONNECTOR_TASK_EXPIRED: "CONNECTOR_TASK_EXPIRED",
};
//# sourceMappingURL=connector-error-codes.js.map